import { constants } from '@trackman/baseball-shared-components';
import { IReviewPlayerExtended } from 'interfaces/review/IReviewPlayer';
import { IError } from 'interfaces/review/IReviewDataRow';

export const isNotSamePosition = (firstPlayer: IReviewPlayerExtended, secondPlayer: IReviewPlayerExtended): boolean => {
  return firstPlayer.defaultPosition !== secondPlayer.defaultPosition && firstPlayer.id === secondPlayer.id;
};

export const isNotDuplicated = (fpPosition: string, spPosition: string, errors: IError[]): boolean => {
  return !errors.find((error) => error.dataKey === `${spPosition}-${fpPosition}`);
};

export const playerHasNoEmptyGuid = (firstPlayer: IReviewPlayerExtended, secondPlayer: IReviewPlayerExtended): boolean => {
  return firstPlayer.id !== constants.emptyGuid && secondPlayer.id !== constants.emptyGuid;
};
